import bwsLogo from '../src/img/bws-logo.png';
import swbLogo from '../src/img/swb-logo-heart.png';

export const themes = {
    default: {
        brand: 'swb',
        logo: swbLogo,
        '--hub-primary': '#7b5fa6',
        '--hub-primary-hover': '#998AC1',
        '--hub-primary-light': '#E7CDDB',
        '--hub-primary-dark': '#59516D',

        '--hub-secondary': '#5B8FF5',
        '--hub-secondary-light': '#81D7F7',
        '--hub-secondary-dark': '#8CB7FA',

        '--hub-aqua': '#5EA697',
        '--hub-aqua-dark': '#739399',

        '--hub-green-light': '#8CC2AF',
        '--hub-green': '#8CC290',

        '--hub-peach': '#C2968C',

        '--wba-gray': '#1c232f',

        '--nav': '#A581B1',
        '--nav-dark': '#391472',

        '--dark-purple': '#7C5FA6',
        '--dark-blue': '#4D6079',

        '--light-blue': '#DEEFFF',
        '--light-purple': '#DDCCDF',

        '--portal-light': '#DB567C',
        '--portal-medium': '#BE325A',
        '--portal-dark-purple': '#5C356C',
        '--portal-dark-blue': '#360F41',

        '--wba-dark-pink': '#ab366a',
        '--wba-primary': '#ac336a',
        '--wba-primary-hover': '#962759',
        '--wba-secondary': '#3e7dba',
        '--wba-secondary-light': '#5b99d6',
    },
    bws: {
        brand: 'bws',
        logo: bwsLogo,
        '--hub-primary': '#7B5FA6',
        '--hub-primary-hover': '#998AC1',
        '--hub-primary-light': '#86A1EB',
        '--hub-primary-dark': '#86A1EB',

        '--hub-secondary': '#3e7dba',
        '--hub-secondary-light': '#5b99d6',
        '--hub-secondary-dark': '#2f5f91',

        '--hub-aqua': '#5EA697',
        '--hub-aqua-dark': '#739399',

        '--hub-green-light': '#8CC2AF',
        '--hub-green': '#8CC290',

        '--hub-peach': '#C2968C',

        '--wba-gray': '#1c232f',

        '--nav': '#ac336a',
        '--nav-dark': '#323594',

        '--dark-purple': '#5C356C',
        '--dark-blue': '#360F41',

        '--light-blue': '#DEEFFF',
        '--light-purple': '#86A1EB',
        'nav-item-active ': '#BCA6C4',
        '--portal-light': '#22246F',
        '--portal-medium': '#86A1EB',
        '--portal-dark-purple': '#22246F',
        '--portal-dark-blue': '#360F41',

        '--wba-dark-pink': '#ab366a',
        '--wba-primary': '#ac336a',
        '--wba-primary-hover': '#962759',
        '--wba-secondary': '#3e7dba',
        '--wba-secondary-light': '#5b99d6',
    },
};